
export enum Path {
  Home = '/',
  About = '/about',
  Contact = '/contact',
  Events = '/events',
  Admission = '/admission',
 



 

}
